var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99976 14.3508L8.55936 13.7724C8.22936 13.3392 5.33496 9.48244 5.33496 7.63084C5.33496 5.61004 6.97896 3.96484 8.99976 3.96484C11.0206 3.96484 12.6646 5.60884 12.6646 7.63084C12.6646 9.48244 9.77016 13.3392 9.44016 13.7724L8.99976 14.3508ZM8.99976 4.20484C7.11096 4.20484 5.57496 5.74204 5.57496 7.63084C5.57496 9.40444 8.42616 13.2 8.75016 13.6272L8.99976 13.9548L9.24936 13.6272C9.57456 13.2 12.4246 9.40444 12.4246 7.63084C12.4246 5.74204 10.8874 4.20484 8.99976 4.20484Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00027 4.51562C7.28187 4.51562 5.88867 5.90883 5.88867 7.62723C5.88867 9.34563 9.00027 13.434 9.00027 13.434C9.00027 13.434 12.1119 9.34563 12.1119 7.62723C12.1119 5.90883 10.7187 4.51562 9.00027 4.51562ZM9.00027 8.86683C8.31627 8.86683 7.76067 8.31243 7.76067 7.62723C7.76067 6.94203 8.31507 6.38763 9.00027 6.38763C9.68547 6.38763 10.2399 6.94203 10.2399 7.62723C10.2399 8.31243 9.68547 8.86683 9.00027 8.86683Z",
    fill: "#004C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/IconLocation.2bee0c359dbe06aad412d108ce51ab82.svg";
export { ForwardRef as ReactComponent };